import { gql } from "graphql-request";

export const SEND_ACCOUNT_RECOVERY = gql`
  mutation SendAccountRecovery($rut: Float!, $transactionId: String!, $skipEmail: Boolean) {
    sendAccountRecovery(rut: $rut, transactionId: $transactionId, skipEmail: $skipEmail) {
      isValid
      email
    }
  }
`;

export const SEND_PASSWORD_RECOVERY = gql`
  mutation SendPasswordRecovery($rut: String!) {
    sendPasswordRecovery(rut: $rut) {
      message
    }
  }
`;
